import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@/assets/css/style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import VueLazyload from "vue-lazyload"; // Lazyload kütüphanesini import ettik

// Lazyload konfigürasyonu
createApp(App)
  .use(router)
  .use(VueLazyload, {
    preLoad: 1.3, // Resmin görünmeden önce yükleneceği mesafe
    loading: require("@/assets/loading.gif"), // Yükleniyor animasyonu (kendi görselinizi kullanabilirsiniz)
    attempt: 1, // Resmi ne kadar hızlı yüklemesi gerektiğini belirtir (1 deneme yeterli)
  })
  .mount("#app");
